import { organisationActions } from './reducers';

export const { setCurrentOrganisationAction, clearCurrentOrganisationAction, changeCurrentOrganisationAction } =
  organisationActions;
